export default function Invoice(data) {
    let invoice = data || {};
    this.id = invoice.id;
    this.amount = invoice.amount / 100;
    this.created = new Date(invoice.created);
    this.number = invoice.number;
    this.pdfUrl = invoice.pdfUrl;
    this.status = invoice.status;
    this.paid = invoice.paid;
}